import React from 'react';
import styled from 'styled-components';

const Button = (props) => {
  const {
    disabled,
    _onClick,
    children,
    margin,
    width,
    padding,
    bgColor,
    color,
    border,

    wide
  } = props;

  const styles = {
    margin: margin,
    width: width,
    padding: padding,
  };

  if (wide) {
    return (
      <React.Fragment>
        <WideButton onClick={_onClick}>{children}</WideButton>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ElButton disabled={disabled} {...styles} onClick={_onClick}>
        {children}
      </ElButton>
    </React.Fragment>
  );
};

Button.defaultProps = {
  children: null,
  _onClick: () => {},
  is_float: false,
  margin: false,
  width: '100%',
  padding: '12px 0px'
};

const ElButton = styled.button`
  width: ${(props) => props.width};
  background-color: ${(props) => props.btnColor};
  color: #ffffff;
  padding: ${(props) => props.padding};
  box-sizing: border-box;
  border-radius: 12px;
  border: none;
  ${(props) => (props.margin ? `margin: ${props.margin};` : '')};
  cursor: pointer;
  border-color: ${(props) => (props.disabled ? 'gray' : '#ffffff')};
  ${(props) =>
    props.disabled
      ? `background-color:gray; color:white`
      : `
  background-color:#212121; color:white
  `}
`;

const WideButton = styled.button`
  width: 100%;
  height: 7vh;
  background-color: ${(props) => (props.bgColor ? `${props.bgColor}` : '#FF7A00')};
  color: ${(props) => (props.color ? `${props.color}` : '#ffffff')};
  box-sizing: border-box;
  font-weight: 600;
  position: absolute;
  bottom: 20vh;
  text-align: center;
  vertical-align: middle;
  border: ${(props) => (props.border ? `${props.border}` : 'none')};
  border-radius: 8px;
`;

export default Button;